import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { billRoutes } from '../pages/bills/routes';
import { financialAccountRoutes } from '../pages/financial-accounts/routes';
import { financialOperationRoutes } from '../pages/financial-operations/routes';
import { memberRoutes } from '../pages/members/routes';
import { meterRoutes } from '../pages/meters/routes';
import { paymentRoutes } from '../pages/payments/routes';
import { projectRoutes } from '../pages/projects/routes';
import { reportRoutes } from '../pages/reports/routes';
import { unpaidBillsRoutes } from '../pages/unpaid-bills/routes';
import ErrorPage from './error-page';

// Layouts
const AppLayout = lazy(() => import('../layouts/AppLayout'));

// Dashboard
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));

export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Dashboard /> },
      ...memberRoutes,
      ...meterRoutes,
      ...billRoutes,
      ...paymentRoutes,
      ...projectRoutes,
      ...financialAccountRoutes,
      ...financialOperationRoutes,
      ...unpaidBillsRoutes,
    ],
  },
  ...reportRoutes,
];
